import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from "@mantine/core";
import { panelBg, panelRadius, panelWidth, standardThickBorder } from "../utils/style.js";
export const PrimaryPanel = ({ children, width }) => {
    return (_jsx(Flex, { direction: "column", h: "100%", w: width ?? panelWidth, bg: panelBg, p: "sm", gap: "md", style: {
            borderRadius: panelRadius,
            border: standardThickBorder,
        }, children: children }));
};
export const SecondaryPanel = ({ children }) => {
    return (_jsx(Flex, { direction: "column", h: "100%", w: panelWidth, bg: panelBg, p: "sm", gap: "md", style: {
            borderTopRightRadius: panelRadius,
            borderBottomRightRadius: panelRadius,
            border: standardThickBorder,
            borderLeft: "none",
        }, children: children }));
};
